import React, { useEffect } from "react";
import RefreshIcon from "@mui/icons-material/Refresh";
import LogoutIcon from "@mui/icons-material/Logout";

const MODAL_TITLE = "Network Connection Error";
const MODAL_BODY =
  "Network connection error. Please check after some time.";

const secondaryBtnStyle = {
  background: "#fff",
  border: "1px solid #ced4da",
  color: "#495057",
  fontWeight: 600,
  letterSpacing: "0.5px",
  fontSize: "13px",
  borderRadius: "6px",
  textTransform: "uppercase",
  padding: "10px 28px",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
};

const primaryBtnStyle = {
  background: "linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)",
  border: "none",
  color: "white",
  fontWeight: 600,
  letterSpacing: "0.5px",
  fontSize: "13px",
  boxShadow: "0 4px 15px rgba(13, 110, 253, 0.45)",
  borderRadius: "6px",
  textTransform: "uppercase",
  padding: "10px 28px",
  transition: "all 0.3s ease",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
};

/**
 * Shown when the API is unreachable (hung process, IIS recycle, wrong port, network).
 * Styled to match Approve/Reject modals on View Service Request.
 */
export default function ApiUnreachableModal({ open, onReload, onLogout }) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="api-unreachable-modal-backdrop"
      role="presentation"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 10050,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
        overflow: "auto",
      }}
    >
      <div
        className="api-unreachable-modal-container"
        role="dialog"
        aria-modal="true"
        aria-labelledby="api-unreachable-title"
        style={{
          position: "relative",
          backgroundColor: "white",
          borderRadius: "8px",
          width: "95%",
          maxWidth: "520px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          className="api-unreachable-modal-header"
          style={{
            padding: "20px",
            borderBottom: "1px solid #dee2e6",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f8f9fa",
            borderRadius: "8px 8px 0 0",
            flexShrink: 0,
          }}
        >
          <h3
            id="api-unreachable-title"
            style={{ margin: 0, color: "#333", fontWeight: 600, fontSize: "18px" }}
          >
            {MODAL_TITLE}
          </h3>
        </div>

        <div
          className="api-unreachable-modal-body"
          style={{ padding: "20px", flex: "1 1 auto" }}
        >
          <p
            style={{
              margin: 0,
              fontSize: "14px",
              color: "#333",
              lineHeight: 1.5,
            }}
          >
            {MODAL_BODY}
          </p>
        </div>

        <div
          className="api-unreachable-modal-footer"
          style={{
            borderTop: "1px solid #dee2e6",
            padding: "20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "0 0 8px 8px",
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            flexShrink: 0,
          }}
        >
          {typeof onLogout === "function" && (
            <button type="button" className="btn" onClick={onLogout} style={secondaryBtnStyle}>
              <LogoutIcon style={{ fontSize: "18px" }} />
              Logout
            </button>
          )}
          <button
            type="button"
            className="btn"
            onClick={onReload}
            autoFocus
            style={primaryBtnStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(13, 110, 253, 0.6)";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 4px 15px rgba(13, 110, 253, 0.45)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <RefreshIcon style={{ fontSize: "18px" }} />
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}
